import SignOutContainer from './sign_out_container';

const SignOut = SignOutContainer;
export default SignOut;
